import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { RadioButtonComponent } from '@connect-services/src/lib/components/radio-button/radio-button.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RadioButtonComponent],
    selector: 'app-selectable-header',
    templateUrl: './selectable-header-reference-data.component.html',
})
export class SelectableHeaderReferenceDataComponent {
    public readonly checked = input<boolean>(false);
    public readonly containerClass = input<string>('');
    public readonly label = input.required<string>();
    public readonly radioClass = input<string>('');

    public readonly selected = output<MouseEvent>();

    protected onClick(event: MouseEvent): void {
        event.stopPropagation();
        this.selected.emit(event);
    }
}
